import { faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import RecipeCard from './Recipe-card';
import { deleteRecipe, getRecipeByUserId } from './api';
import { auth } from './firebase';
import Heading1 from './headings/Heading1';

function UserRecipes() {
  const [userRecipes, setUserRecipes] = useState([]);
  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const handleCreateRecipe = () => {
    if (user) {
      navigate('/recipes/create');
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    if (user) {
      getRecipeByUserId(user.uid)
        .then((recipes) => {
          setUserRecipes(recipes);
        })
        .catch((error) => {
          console.error('Error fetching user recipes:', error);
        });
    } else {
      setUserRecipes([]);
    }
  }, [user]);

  const handleEditClick = (recipeId) => {
    window.location = `/editRecipe/${recipeId}`;
  };

  const handleDeleteClick = (recipeId) => {
    if (window.confirm("Are you sure you want to delete this recipe?") === false) {
      return;
    }
    deleteRecipe(recipeId);
    getRecipeByUserId(user.uid)
      .then((recipes) => {
        setUserRecipes(recipes);
      });
  };

  return (
    <div className="w-full py-12 px-4 sm:px-6 lg:px-8 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
          <Heading1 title="My Recipes" />
          <button
            className="px-6 py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-bold rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
            onClick={() => { window.location = '../recipe/create' }}
          >
            <FontAwesomeIcon icon={faPlus} />
            &nbsp;
            New Recipe
          </button>
        </div>

        {/* Recipes Grid */}
        {userRecipes.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {userRecipes.map((recipe, index) => (
              <div key={recipe.id || index} className="relative group">
                <RecipeCard recipe={recipe} />
                {/* Action Buttons Bar */}
                <div className="mt-2 flex gap-2">
                  <button
                    className="flex-1 py-2 px-3 bg-gray-50 text-gray-600 text-sm font-medium rounded-lg hover:bg-blue-50 hover:text-blue-600 transition-all duration-200 flex items-center justify-center gap-1.5"
                    onClick={() => handleEditClick(recipe.id)}
                    aria-label="Edit recipe"
                  >
                    <FontAwesomeIcon icon={faEdit} className="text-sm" />
                    <span>Edit</span>
                  </button>
                  <button
                    className="flex-1 py-2 px-3 bg-gray-50 text-gray-600 text-sm font-medium rounded-lg hover:bg-red-50 hover:text-red-600 transition-all duration-200 flex items-center justify-center gap-1.5"
                    onClick={() => handleDeleteClick(recipe.id)}
                    aria-label="Delete recipe"
                  >
                    <FontAwesomeIcon icon={faTrash} className="text-sm" />
                    <span>Delete</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="text-6xl mb-4">👨‍🍳</div>
            <h3 className="text-2xl font-bold text-gray-700 mb-2">No recipes yet</h3>
            <p className="text-gray-500 mb-6">Start creating your first recipe!</p>
            <button
              className="px-6 py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-bold rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
              onClick={handleCreateRecipe}
            >
              <FontAwesomeIcon icon={faPlus} />
              &nbsp;
              Create Recipe
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserRecipes;
